// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9c782ea0","387":"6718262d","409":"84427eb9","436":"a74abeb9","453":"e1ed1f42","598":"c57348b2","678":"51e0b472","866":"409176d0","879":"fd39bdb5","896":"1989d72e","951":"2aa0dc0c","967":"f51e6b45"}[chunkId] + ".chunk.js";
};